export default __webpack_public_path__ + "static/media/submitted-form-dark.69881d17.svg";